import type { RoomCalendarBooking } from '../types';
import { formatMalaysiaIsoTime } from '../lib/utils';

export default function BookingDetailContent({
  booking,
  roomName,
  showTitle = true,
}: {
  booking: RoomCalendarBooking;
  roomName: string;
  showTitle?: boolean;
}) {
  const department = booking.host_department?.trim();
  return <div className="booking-popup-content">
    {showTitle ? <h3>{booking.title}</h3> : null}
    <p className="booking-popup-room">{roomName}</p>
    <p className="booking-popup-time">{formatMalaysiaIsoTime(booking.starts_at)} – {formatMalaysiaIsoTime(booking.ends_at)}</p>
    {booking.status && booking.status !== 'RESERVED' ? <p className="booking-history-status">{booking.status === 'CANCELLED_RELEASED' ? 'Cancelled booking · Released' : booking.status === 'RELEASED' ? 'Released' : 'Cancelled booking · Room retained'}</p> : null}
    <div className="booking-popup-host">
      <span>Host</span>
      <strong>{booking.host_full_name ?? 'MTIB staff'}</strong>
      {department ? <small>{department}</small> : null}
    </div>
  </div>;
}
